<template>
        <v-card class="my-custom-card">
            
            <v-app-bar class="mb-5" flat color="transparent">
                <v-btn large icon @click="$emit('cancel')">
                    <v-icon color="primary" @click="$router.push('/issuanceIncoice')">mdi-arrow-left</v-icon>
                </v-btn>

                <v-toolbar-title class="title">
                    Criar Pré-Nota
                </v-toolbar-title>

                <v-spacer></v-spacer>

                <v-btn color="primary" @click="createEmitNf">
                    <span>
                        Salvar
                    </span>
                </v-btn>
        
            </v-app-bar>

            <v-container> </v-container>

            <v-form :key="componentKey" ref="formPrincipal" class="d-flex flex-column gap-5">

                <div v-if="emitNotaFiscal.typeNf != 'Nota Fiscal de Serviço'">

                    <v-expansion-panels class="mb-5">
                        <v-expansion-panel v-if="emitNotaFiscal.notaFiscalDeRemessa == false && emitNotaFiscal.typeNf != 'Nota Fiscal de Serviço'">
                            <v-expansion-panel-header class="font-weight-bold">
                                Nota Referenciada
                            </v-expansion-panel-header>

                            <v-expansion-panel-content>
                                <div style="display: flex; justify-content: center; align-items: center; gap: 5px;">
                                    <v-text-field style="margin-right: 5px;" learable outlined label="Nota Fiscal Mãe (Chave Acesso)" v-model="searchNotaChaveAcesso" />
                                    <v-btn @click="searchNotaFisca" style="margin-bottom: 20px;" color="primary" :disabled="!searchNotaChaveAcesso">
                                        <v-icon>mdi-magnify</v-icon>
                                    </v-btn>
                                </div>
                                    <v-data-table
                                        v-model="selected"
                                        :headers="headers"
                                        :items="itemsData"
                                        class="elevation-1"
                                        disable-sort
                                        hide-default-footer
                                        show-select 
                                        color="primary"
                                        single-select
                                    >
                                        <template  v-slot:[`item.valueNf`]="{ item }">
                                            <span>
                                                {{ Number(item.valueNf).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }) }}
                                            </span>
                                        </template>
                                </v-data-table>
                            </v-expansion-panel-content>
                        </v-expansion-panel>
                    </v-expansion-panels>

                    <v-row>
                        <v-col cols="12" sm="6" md="4" v-if="emitNotaFiscal.typeNf != 'Nota Fiscal de Serviço'">
                            <v-autocomplete 
                                clearable 
                                outlined 
                                label="Job" 
                                v-model="notaFiscal.job" 
                                :items="projects" 
                                item-value="id"
                                item-text="code"
                                return-object
                                @change="slectedJob"
                            />
                        </v-col>

                        <v-col cols="12" sm="6" md="4" v-if="emitNotaFiscal.notaFiscalDeRemessa && emitNotaFiscal.typeNf != 'Nota Fiscal de Serviço'">

                            <v-autocomplete 
                                clearable outlined label="Fornecedor" 
                                v-model="emitNotaFiscal.destinatario" 
                                :items="fornecedores" 
                                item-value="id"
                                item-text="nomeFantasia"
                                @change="fornecedorSelected"
                                return-object
                            />
                        </v-col>
                        
                        <v-col cols="12" sm="6" md="4" v-else>

                            <v-autocomplete 
                                clearable outlined label="Cliente" 
                                v-model="emitNotaFiscal.destinatario" 
                                :items="clientes" 
                                item-value="id"
                                item-text="nomeFantasia"
                                return-object
                            />
                        </v-col>
                        
                        <v-col cols="12" sm="6" md="4" :key="updtaeSum">
                            <v-text-field 
                                clearable outlined 
                                label="Valor Total da Nota"
                                
                                :value="formatMoeda(emitNotaFiscal.valorNf / 100)"
                                :readonly="emitNotaFiscal.typeNf !== 'Nota Fiscal de Serviço'"
                            />
                        </v-col>
                        <!-- <v-col cols="12" sm="6" md="3">
                            <v-combobox 
                                label="Status da Nota" 
                                :items="optionStatus" 
                                outlined 
                                clearable 
                                v-model="emitNotaFiscal.statusNf"
                            ></v-combobox>
                        </v-col> -->

                </v-row>
                </div>

                <div v-if="emitNotaFiscal.typeNf != 'Nota Fiscal de Serviço'">
                    <NotaFiscal 
                        :item="notaFiscal"
                        :projects="projects"
                        :userInfo="emitNotaFiscal.destinatario"
                        :pacelasCads="parcelas"
                        :valorNota="emitNotaFiscal.valorNf"
                        :jobSelected="notaFiscal.job"
                        :romaneios="romaneios"
                        :isNfRemessa="emitNotaFiscal.notaFiscalDeRemessa"
                        :isNfReferenciada="isCfopsNfMae.includes(this.notaFiscal.cfop)"
                        ref="nfComponent"
                        @itens-nf="handleNfItens"
                        @nf="handleNotaFiscal"
                        @sumItens="updateSum"
                        @parcelas="handleParcelas"
                    />
                </div>

                <div v-else>
                    <NotaFiscalServico 
                        :item="objeNotaServico"
                        :projects="projects"
                        :userInfo="emitNotaFiscal.destinatario"
                        :isOpen="dialog"
                        :valorNf="emitNotaFiscal.valorNf"
                        :clientes="clientes"
                        @selectedCliente="selectedCliente"
                        @nf="handleNotaFiscalServico"
                        :pacelasCads="parcelas"
                        @parcelas="handleParcelas"
                    />
                </div>
            </v-form>

        </v-card>
</template>

<script>
import Vue from 'vue';
import NotaFiscal from './formCreateNF/NotaFiscal.vue';
import NotaFiscalServico from './formCreateNF/NotaFiscalServico.vue';
import {VMoney} from 'v-money'
import moment from 'moment';
import EntityService from '../../services/entityService';
export default {
    name: 'CreateIssuanceInvoice',
    //props: ['item'],
    directives: { money: VMoney },
    components: {
        NotaFiscal,
        NotaFiscalServico
    },
    data(){
        return {
            fisDocEntity: new EntityService('FisDocService'),
            fisPreDocEmi: new EntityService('FisPreDocEmi'),
            emissaoDoc: new EntityService('EmissaoNotasFiscais'),
            optionStatus: ['Pendente', 'Emitida', 'Rejeitada', 'Denegada'],
            dialog: false,
            projects: [],
            parcelas: [],
            isCfopsNfMae: ['6922'],
            item: null,
            emitNotaFiscal: {
                notaFiscalDeRemessa: this.$route.params.typeNf == 'Nota Fiscal de Remessa' ? true : false,
                typeNf: 'Nota Fiscal',    
                valorNf: null,
                destinatario: null,
                statusNf: 'Pendente'
            },
            componentKey: 0,
            updtaeSum: 0,
            selected: [],
            itemsData: [],
            notaFiscal: {
                filial: '',
                job: '',
                ncm: '',
                romaneio: [],
                cest: '',
                icms: '',
                baseIcms: '',
                naturezaOp: '',
                cfop: '',
                cnpj: '',
                itens: [],
                uf: '',
                email: '',
                bairro: '',
                numero: '',
                logradouro: '',
                cidade: '',
                cep: '',
                condPag: '',
                codigoCidade: '',
                transportadora: '',
                notaFiscalMae: null
            },
            objeNotaServico: {
                cnpj: null,
                cpfOrCnpjEmitente: null,
                razaoSocialNomeEmitente: null,
                cpfOrCnpjTomador: null,
                razaoSocialNomeTomador: null,
                cnae: null,
                inscricaoMinucipal: '',
                inscricaoMinucipalTomador: '',
                endereco: null,
                localEmissao: null,
                emitenteLogradouro: null,
                emitenteBairro: null,
                localRecebimento: null,
                tipoServico: '',
                descricao: '',
                enqServico: '',
                codMunicipio: '',
                job: null,
                os: null,
                dataEmit: null,
                dateVenc: null,
                valorNota: null,
                pis: null,
                confins: null,
                csll: null,
                ir: null,
                inss: null,
                iss: null,
                aliIss: null,
                valueIss: null,
                tributos: null,
                liquidos: null,
                jobItens: [],
                regimeTributario: null,
                tributacao: null,
                aliquota: null
            },
            nfItens: [],
            romaneios: [],
            fornecedores: [],
            clientes: [],
            optionTypeNf: ['Nota Fiscal', 
                'Nota Fiscal Mãe', 
                'Nota Fiscal de Remessa Venda',
                'Nota Fiscal de Serviço'
            ],
            money: {
                locale: "pt-BR",
                decimal: ',',
                thousands: '.',
                prefix: '',
                precision: 2,
                masked: false
            },
            headers: [
                { text: 'Tipo de Nota Fiscal', value: 'tipoNotaFiscal' },
                { text: 'Status', value: 'statusNf' },
                { text: 'Chave de Acesso', value: 'chaveAcesso' },
                { text: 'Valor', value: 'valueNf' },
            ],
            searchNotaChaveAcesso: ''
        }
    },
    methods: {
        async getJob(clienteId){
            let response
            
            if(!clienteId){
                response = await Vue.prototype.$http.get(`/Entity/Project`, {
                    params: {
                        page: 1,
                        limit: 9999
                    }
                });
            } else {
                response = await Vue.prototype.$http.get(`/Entity/Project/search-fields`, {
                    params: {
                        page: 1,
                        limit: 9999,
                        searchFields: 'cliente',
                        value: clienteId
                    }
                });
            }

            this.projects = response.data.data.data
        },

        async getClientes(id){
            const response = await Vue.prototype.$http.get(`/Entity/Cliente`, {
                params: {
                    page: 1,
                    limit: 9999,
                    ids: id
                }
            });

            this.clientes = response.data.data.data
            return this.clientes[0]
        },

        async getFornecedores(id){
            const response = await Vue.prototype.$http.get(`/Entity/Fornecedor`, {
                params: {
                    page: 1,
                    limit: 9999,
                    ids: id
                }
            });

            this.fornecedores = response.data.data.data
            return this.fornecedores
        },


        async getRomaneios(jobId){
            const response = await Vue.prototype.$http.post('/View/run', {
                "params": [ { dataType: "string", name: "jobId", value: jobId } ],
                "viewId": "1baf1963-3349-4644-b65f-795c33f45c1a",
                "page": 1,
                "limit": 3000000

            })

            // console.log("getRomaneios >>> ", jobId, response.data.data.data)

            return response.data.data.data
        },

        handleNfItens(e){
            this.nfItens = e
        },


        async slectedJob(value){
            if(!this.emitNotaFiscal.notaFiscalDeRemessa && this.emitNotaFiscal.typeNf == 'Nota Fiscal'){
                this.emitNotaFiscal.destinatario = await this.getClientes(value.cliente)
            }

            // this.emitNotaFiscal.valorNf = value.valorJob * 100
        },

        async fornecedorSelected(value){
            if(this.romaneios.length == 0) this.romaneios = await this.getRomaneios(this.notaFiscal.job?.id || this.notaFiscal.job)

            // console.log('romaneios >>> ', this.romaneios, value.id)
            this.romaneios = this.romaneios?.filter((rm) => rm.fornecedor == value.id) || []
        },

        async selectedCliente(value){
            if(this.emitNotaFiscal.typeNf == 'Nota Fiscal de Serviço'){
                this.emitNotaFiscal.destinatario = value
                await this.getJob(value.id)
            }
        },

        handleParcelas(e){
            this.parcelas = e
        },

        handleNotaFiscal(e){
            this.notaFiscal = e
        },

        handleNotaFiscalServico(e){
            this.objeNotaServico = e

            if(e?.jobItens?.length > 0){
                this.emitNotaFiscal.valorNf = 0 
                e?.jobItens?.map((item) => {
                    this.emitNotaFiscal.valorNf += item.precoTotal
                })
            }

        },

        formatMoeda(valor) {
            return valor.toLocaleString("pt-BR", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            });
        },

        parseMoeda(valor) {
            if (!valor) return 0;

            valor = valor.toString().trim();

            // Se vier nesse formato estranho: 395.039.30
            // pega os últimos 2 dígitos como centavos
            if (/^\d{1,3}(\.\d{3})*\.\d{2}$/.test(valor)) {
                // remove pontos
                valor = valor.replace(/\./g, '');
                // insere vírgula antes dos 2 últimos dígitos
                valor = valor.slice(0, -2) + ',' + valor.slice(-2);
            }

            return parseFloat(
                valor.replace(/\./g, '')   // remove milhar
                    .replace(',', '.')    // vírgula -> ponto decimal
            ) || 0;
        },

        toIntegerInput(value) {
            if (value == null || value === '') return 0;
            if (typeof value === 'number') return Number.isFinite(value) ? value : 0;

            return Number(
                String(value)
                    .replace(/\./g, '')
                    .replace(/,/g, '')
            ) || 0;
        },

        toStringInput(value) {
            if (value == null) return '';
            return String(value);
        },

        updateSum(sum){
            this.emitNotaFiscal.valorNf = Math.round(this.parseMoeda(sum))
            this.updtaeSum += 1
        },


        resetValues(){
            this.notaFiscal = {
                filial: '',
                job: '',
                ncm: '',
                romaneio: [],
                cest: '',
                icms: '',
                baseIcms: '',
                naturezaOp: '',
                cfop: '',
                cnpj: '',
                itens: [],
                uf: '',
                email: '',
                bairro: '',
                numero: '',
                logradouro: '',
                cidade: '',
                cep: '',
                condPag: '',
                codigoCidade: '',
                transportadora: ''
            }
        },

        validate() {
            const formPrincipalValido = this.$refs.formPrincipal?.validate() ?? false;

            const formInternoValido =
            this.$refs.nfComponent?.$refs.formInterno?.validate?.() ?? true;

            if (formPrincipalValido && formInternoValido) {
                return true
            } else {
                return false
            }
        },

        async getParcela(parcelas){

            if(parcelas?.length > 0){
                const response = await Vue.prototype.$http.get('/Entity/FisPreDocEmiFin/search-fields', {
                    params: {
                        ids: parcelas.map((p) => p).join(','),
                        sortField: 'parcelaSequencia',
                        
                    }
                })

                this.parcelas = response.data.data.data.map((p) => {
                    return {
                        id: p.id,
                        numParcela: p.parcelaSequencia, 
                        vencimento: moment(p.dtPag).format('YYYY-MM-DD'), 
                        vrlParcela: p.vlr
                    }
                })
            }
        },

        async getAutoIncFisPreDoc(){
            const response = await this.fisPreDocEmi.autoInc("FisPreDocEmi", "codigo", "######")
            return response.data
        },

        async getItemNf(id){
            const response = await Vue.prototype.$http.post(`/View/run`,
                {
                    "params": [
                        { dataType: "string", name: "id", value: id },
                    ],
                    "viewId": "2a39c593-02d0-46d4-be8c-6dc43dc18c9a",
                    "page": 1,
                    "limit": 1
                }
            );

            const value = response.data.data.data[0]


            if(value){

                if(value.notaFiscal[0]?.parcelas) await this.getParcela(value.notaFiscal[0]?.parcelas)

                if(value.notaFiscalServico[0]?.parcelas) await this.getParcela(value.notaFiscalServico[0]?.parcelas)

                this.emitNotaFiscal = {
                    destinatario: !value.notaFiscalDeRemessa ? value.destinatario : value.destinatarioFornecedor,
                    statusNf: value.statusNf,
                    valorNf: Number(value.valueNf) * 100 || 0,
                    typeNf: value.tipoNotaFiscal.replaceAll("_", " "),
                    notaFiscalDeRemessa: value.notaFiscalDeRemessa,
                    id: value._id
                }


                // console.log('TESTE >>> ', value.valueNf / 100, this.emitNotaFiscal.valorNf)

                if(value.notaFiscal[0]?._id){

                    const response = await Vue.prototype.$http.get('/Entity/Project/' + value.notaFiscal[0].job)
                    const job = response.data.data
                    await this.slectedJob(job)

                    let romaneios = await this.getRomaneios(job?.id || job)
                    romaneios.filter((romaneio) =>  value.notaFiscal[0].romaneio.includes(romaneio._id))

                    // console.log('romaneios >>> ', romaneios.filter((romaneio) =>  value.notaFiscal[0].romaneio.includes(romaneio._id)))

                    this.notaFiscal = {
                        codigo: value.notaFiscal[0].codigo,
                        id: value.notaFiscal[0]._id,
                        filial: value.notaFiscal[0].filial,
                        job: job,
                        romaneio: romaneios.filter((romaneio) =>  value.notaFiscal[0].romaneio.includes(romaneio._id)),
                        //cest: value.notaFiscal[0].cest,
                        icms: value.notaFiscal[0].aliIcms,
                        baseIcms: value.notaFiscal[0].baseIcms,
                        naturezaOp: value.notaFiscal[0].naturezaOperacao,
                        defFiscais: value.notaFiscal[0].defFiscais || undefined,
                        //destinatario: value.notaFiscal[0].destinatario,
                        cnpj: value.notaFiscal[0].cnpj,
                        itens: value.notaFiscal[0].itens,
                        uf: value.notaFiscal[0].uf,
                        email: value.notaFiscal[0].email,
                        bairro: value.notaFiscal[0].destinatarioBairro,
                        numero: value.notaFiscal[0].destinatarioNumero,
                        logradouro: value.notaFiscal[0].destinatarioLogradouro,
                        cidade: value.notaFiscal[0].destinatarioCidade,
                        cep: value.notaFiscal[0].destinatarioCep,
                        condPag: value.notaFiscal[0].condicaoPagamento,
                        codigoCidade: value.notaFiscal[0].codigoCidade,
                        notaFiscalMae: value.notaFiscal[0]?.notaFiscalMae || undefined,
                        addRetirada: value.notaFiscal[0]?.addRetirada,
                        transportadora: value.notaFiscal[0]?.transportadora,
                        dataSaida: moment(value.notaFiscal[0]?.dataSaida).format('YYYY-MM-DD'),
                        quantidade: value.notaFiscal[0].volumeQuantidade,
                        especie: value.notaFiscal[0].especie,
                        marca: value.notaFiscal[0].marca,
                        numeracao: value.notaFiscal[0].volumeNumeracao,
                        pesoBruto: value.notaFiscal[0].pesoBruto,
                        pesoLiquido: value.notaFiscal[0].pesoLiquido,
                        valorFrete:  value.notaFiscal[0].valorFrete,
                        valorSeguro: value.notaFiscal[0].valorSeguro,
                        valorDesconto: value.notaFiscal[0].valorDesconto,
                        valorOutros: value.notaFiscal[0].valorOutros,
                        ncm: value.notaFiscal[0].ncm,
                        cest: value.notaFiscal[0].cest,
                        cfop: value.notaFiscal[0].cfop,
                        operacaoFiscal: value.notaFiscal[0].fisOper,
                        informacaoAdd: value.notaFiscal[0].informacaoAdd,
                        meioPagamento: value.notaFiscal[0]?.meioPagamento?.replaceAll('_', ' ') || ''
                    }

                    // console.log('Nota Fiscal >>> ', this.notaFiscal)

                } else if(value.notaFiscalServico[0]?._id){

                    console.log('NF SERVICE >>> ', value.notaFiscalServico[0])

                    this.objeNotaServico = {
                        id: value.notaFiscalServico[0]?._id,
                        cpfOrCnpjEmitente: value.notaFiscalServico[0].emitenteCpfOrCnpj,
                        razaoSocialNomeEmitente: value.notaFiscalServico[0].emitenteRazaoSocial,
                        cnae: value.notaFiscalServico[0].cnae,
                        aliIss: value.notaFiscalServico[0].aliIss,
                        codMunicipio: value.notaFiscalServico[0].codMunicipio,
                        inscricaoMinucipal: value.notaFiscalServico[0].emitenteIm,
                        localEmissao: value.notaFiscalServico[0].emitenteLocalEmissao,
                        emitenteLogradouro: value.notaFiscalServico[0].emitenteLogradouro,
                        emitenteBairro: value.notaFiscalServico[0].emitenteBairro,
                        emitenteTipoEnquadramento: value.notaFiscalServico[0].enqServico,
                        cpfOrCnpjTomador: value.notaFiscalServico[0].tomadorCpfOrCnpj,
                        razaoSocialNomeTomador: value.notaFiscalServico[0].tomadorRazaoSocial,
                        inscricaoMinucipalTomador: value.notaFiscalServico[0].inscricaoMinucipalTomador,
                        endereco: value.notaFiscalServico[0].tomadorEndereco,
                        localRecebimento: value.notaFiscalServico[0].tomadorLocalRecebido,
                        descricao: value.notaFiscalServico[0].descricao,
                        emitenteCodCidade: value.notaFiscalServico[0].emitenteCodCidade,
                        baseCalculo: value.notaFiscalServico[0].vrlBaseCalc,
                        iss: value.notaFiscalServico[0].vlrISS,
                        ir: value.notaFiscalServico[0].vlrIR,
                        pis: value.notaFiscalServico[0].vlrPIS,
                        confins: value.notaFiscalServico[0].vlrCOFINS,
                        csll: value.notaFiscalServico[0].vlrSCLL,
                        dateVenc: value.notaFiscalServico[0].dataVenc,
                        liquidos: value.notaFiscalServico[0].vlrLiquido,
                        job: value.notaFiscalServico[0].job,
                        tipoServico: value.notaFiscalServico[0].tipoServico,
                        tomadorCep: value.notaFiscalServico[0].tomadorCep,
                        tomadorEmail: value.notaFiscalServico[0].tomadorEmail,
                        tomadorNumero: value.notaFiscalServico[0].tomadorNumero,
                        tomadorComplemento: value.notaFiscalServico[0].tomadorComplemento,
                        tomadorUf: value.notaFiscalServico[0].tomadorUf,
                        codigoCidade: value.notaFiscalServico[0].codigoCidade,
                        jobItens: value.notaFiscalServico[0].jobItens,
                        jobItensList: value.notaFiscalServico[0].jobItensList,
                        regimeTributario: value.notaFiscalServico[0]?.regimeTributario || undefined,
                        enquadramento: value.notaFiscalServico[0].enquadramentoServico || undefined,
                        tributacaoMunicipal: { 
                            ...value.notaFiscalServico[0]?.tributacao[0],
                            id: value.notaFiscalServico[0]?.tributacao[0]?._id
                        },
                        aliquota: value.notaFiscalServico[0].aliquota,
                        imposto: Number(value.notaFiscalServico[0].imposto) * 100,
                        dedutivel: Number(value.notaFiscalServico[0].dedutivel) * 100,
                    }
                } else {
                    this.objeNotaServico = {}
                    this.notaFiscal = {}
                }

                this.componentKey += 1
                this.updtaeSum += 1

            } else {
                this.objeNotaServico = {}
                this.notaFiscal = {}
                this.emitNotaFiscal = {}
            }
        },

        async createParcela(){
            if(this.parcelas.length > 0){
                const parcelasParaCriar = this.parcelas
                    .filter(p => !p.id)
                    .map(p => ({
                        parcelaSequencia: p.numParcela,
                        dtPag: p.vencimento,
                        vlr: Number(p.vrlParcela.replace(/\./g, '').replace(',', '.'))
                    }));

                const parcelasParaAtualizar = this.parcelas
                    .filter(p => !!p.id)
                    .map(p => ({
                        id: p.id,
                        parcelaSequencia: p.numParcela,
                        dtPag: p.vencimento,
                        vlr: Number(p.vrlParcela.replace(/\./g, '').replace(',', '.'))
                    }));

                let responseCriacao = { data: { data: [] } };
                let responseAtualizacao = { data: { data: [] } };

                if (parcelasParaCriar.length > 0) {
                    responseCriacao = await Vue.prototype.$http.post(
                        '/Entity/insertMany/FisPreDocEmiFin',
                        parcelasParaCriar
                    );
                }

                if (parcelasParaAtualizar.length > 0) {
                    responseAtualizacao = await Vue.prototype.$http.put(
                        '/Entity/updateMany/FisPreDocEmiFin',
                        parcelasParaAtualizar
                    );
                }

                return [
                    ...responseCriacao.data.data.map(item => item.id),
                    ...responseAtualizacao.data.data.map(item => item.id)
                ];
            }

            const response = await Vue.prototype.$http.post(
                '/Entity/FisPreDocEmiFin',
                {
                    parcelaSequencia: '1',
                    dtPag: new Date().toISOString().split("T")[0] + "T03:00:00Z",
                    vlr: Number(this.emitNotaFiscal.valorNf.replace(/\./g, '').replace(',', '.'))
                }
            )

            return [
                ...response.data.data
            ]

        },

        async createItensPreNota(){
            console.log('nfItens >>> ', this.nfItens)
            const itensCriar = this.nfItens
                .filter(nf => !nf.id)
                .map(nf => ({
                    ...nf,  
                    aliquotaUf: nf.aliquotaUf != null ? this.toStringInput(nf.aliquotaUf) : '',
                    valorUf: this.toIntegerInput(nf.valorUf),
                    cstIbsCbs: nf.cstIbsCbs || undefined,
                    classificacaoIbsCbs: nf.classificacaoIbsCbs || undefined,
                    percentualBaseCalculoIbsCbs: nf.percentualBaseCalculoIbsCbs ? this.toStringInput(nf.percentualBaseCalculoIbsCbs).replaceAll(/\./g, '').replaceAll(',', '') : '',
                    valorBaseCalculoIbsCbs: this.toIntegerInput(nf.valorBaseCalculoIbsCbs),
                    aliquotaCbs: this.toStringInput(nf.aliquotaCbs),
                    valorCbs: this.toIntegerInput(nf.valorCbs),
                    ipiPercentual: this.toStringInput(nf.ipiPercentual),
                    ipiBaseCalculo: this.toIntegerInput(nf.ipiBaseCalculo),
                    ipiValor: this.toIntegerInput(nf.ipiValor),
                    pisBaseCalculo: this.toIntegerInput(nf.pisBaseCalculo),
                    cofinsBaseCalculo: this.toIntegerInput(nf.cofinsBaseCalculo),
                    resultBaseCalcICMS: this.toIntegerInput(nf.resultBaseCalcICMS),
                    icmsBaseCalculo: this.toIntegerInput(nf.icmsBaseCalculo),
                    icmsValor: this.toIntegerInput(nf.icmsValor),
                    cofinsValor: this.toIntegerInput(nf.cofinsValor),
                    pisValor: this.toIntegerInput(nf.pisValor),
                    valorUnitario: this.toIntegerInput(nf.valorUnitario),
                    valorTotal: this.toIntegerInput(nf.valorTotal),
                    valorFrete: this.toIntegerInput(nf.valorFrete),
                    valorSeguro: this.toIntegerInput(nf.valorSeguro),
                    valorDesconto: this.toIntegerInput(nf.valorDesconto),
                    valorOutros: this.toIntegerInput(nf.valorOutros), 
                }));


            const itensAtualizar = this.nfItens
                .filter(nf => !!nf.id)
                .map(nf => ({
                    ...nf,
                    createAt: undefined,
                    updatedAt: undefined,
                    updateBy: undefined,
                    createBy: undefined,
                    deleteAt: undefined,
                    deleteBy: undefined,
                    aliquotaUf: nf.aliquotaUf != null ? this.toStringInput(nf.aliquotaUf) : '',
                    valorUf: this.toIntegerInput(nf.valorUf),
                    aliquotaCbs: this.toStringInput(nf.aliquotaCbs),
                    valorCbs: this.toIntegerInput(nf.valorCbs),
                    cstIbsCbs: nf.cstIbsCbs || undefined,
                    classificacaoIbsCbs: nf.classificacaoIbsCbs || undefined,
                    percentualBaseCalculoIbsCbs: nf.percentualBaseCalculoIbsCbs ? this.toStringInput(nf.percentualBaseCalculoIbsCbs).replaceAll(/\./g, '').replaceAll(',', '') : '',
                    valorBaseCalculoIbsCbs: this.toIntegerInput(nf.valorBaseCalculoIbsCbs),
                    pedidoDeCompra: nf.pedidoDeCompra || undefined,
                    ipiPercentual: this.toStringInput(nf.ipiPercentual),
                    ipiBaseCalculo: this.toIntegerInput(nf.ipiBaseCalculo),
                    ipiValor: this.toIntegerInput(nf.ipiValor),
                    pisBaseCalculo: this.toIntegerInput(nf.pisBaseCalculo),
                    cofinsBaseCalculo: this.toIntegerInput(nf.cofinsBaseCalculo),
                    resultBaseCalcICMS: this.toIntegerInput(nf.resultBaseCalcICMS),
                    icmsPercentual: this.toStringInput(nf.icmsPercentual),
                    icmsBaseCalculo: this.toIntegerInput(nf.icmsBaseCalculo),
                    icmsValor: this.toIntegerInput(nf.icmsValor),
                    cofinsValor: this.toIntegerInput(nf.cofinsValor),
                    pisValor: this.toIntegerInput(nf.pisValor),
                    valorUnitario: this.toIntegerInput(nf.valorUnitario),
                    valorTotal: this.toIntegerInput(nf.valorTotal),
                    valorFrete: this.toIntegerInput(nf.valorFrete),
                    valorSeguro: this.toIntegerInput(nf.valorSeguro),
                    valorDesconto: this.toIntegerInput(nf.valorDesconto),
                    valorOutros: this.toIntegerInput(nf.valorOutros), 
                }));

                console.log('itensAtualizar >>> ', itensAtualizar)

            let responseCriacao = { data: { data: [] } };
            let responseAtualizacao = { data: { data: [] } };

            if (itensCriar.length > 0) {
                responseCriacao = await Vue.prototype.$http.post(
                    '/Entity/insertMany/FisPreDocEmiItem',
                    itensCriar
                );
            }

            if (itensAtualizar.length > 0) {
                responseAtualizacao = await Vue.prototype.$http.put(
                    '/Entity/updateMany/FisPreDocEmiItem',
                    itensAtualizar
                );
            }

            return [
                ...responseCriacao.data.data.map(item => item.id),
                ...responseAtualizacao.data.data.map(item => item.id)
            ];

        },

        async createEmitNf(){

            const isValidate = this.validate()

            if(!isValidate){
                this.$notfy.error("Formulário Não preenchido corretamente.")
                return
            }

            const filial = localStorage.getItem('CompanySiteIdSelected')

            let fispreDocEmi
            let fisDocService

            // console.log('handle nf ', this.emitNotaFiscal, this.notaFiscal)

            if(this.emitNotaFiscal.typeNf != 'Nota Fiscal de Serviço'){

                if(this.nfItens?.length == 0) {
                    this.$notfy.error("Erro, Precisa adicionar os itens da nota.")
                    return
                }

                let parcelas = []
                if(this.notaFiscal.condPag == 'parcelado' && !this.isCfopsNfMae.includes(this.notaFiscal.cfop)){
                    parcelas = await this.createParcela()
                } 
                
                /*else if(this.parcelas.length > 0 && this.notaFiscal.condPag == 'á vista'){
                    // Remove as parcelas
                    await Promise.all(
                        this.parcelas.map(async (p) => {
                            if(p.id){
                                await Vue.prototype.$http.delete(`/Entity/FisPreDocEmiFin?id=${p.id}`)
                            }
                        })
                    )
                }*/

                let nfItens = []
                if(this.nfItens.length > 0){
                    nfItens = await this.createItensPreNota()
                }

                console.log('ROMANEIO >>> ', this.notaFiscal?.romaneio[0])
                

                const response = await this.fisPreDocEmi.insertOrUpdate({
                    codigo: this.notaFiscal.codigo ? this.notaFiscal.codigo : await this.getAutoIncFisPreDoc(),
                    id: this.notaFiscal.id ? this.notaFiscal.id : undefined,
                    filial: this.notaFiscal.id ? this.notaFiscal.filial : filial,
                    job: this.notaFiscal?.job?.id || undefined,
                    romaneio: this.notaFiscal?.romaneio?.map((r) => {
                        return r?._id || r
                    }) || undefined,
                    transporteTipo: this.notaFiscal?.romaneio[0]?.transporteTipo,
                    cliente: this.emitNotaFiscal.destinatario.id,
                    cnpj: this.notaFiscal.cnpj,
                    //cfop: undefined, // vai vim do schema FisOper
                    //condicaoParcelas: '', //Vai vim do schema CondP
                    statusEmissao: 'DESENVOLVENDO',
                    dataEmissao: new Date().toISOString().split("T")[0] + "T03:00:00Z",
                    naturezaOperacao: this.notaFiscal.naturezaOp,
                    defFiscais: this.notaFiscal.defFiscais || undefined,
                    condicaoPagamento: this.notaFiscal.condPag,
                    destinatarioCep: this.notaFiscal.cep,
                    destinatarioCidade: this.notaFiscal.cidade,
                    destinatarioLogradouro: this.notaFiscal.logradouro,
                    destinatarioNumero: this.notaFiscal.numero,
                    destinatarioBairro: this.notaFiscal.bairro,
                    codigoCidade: this.notaFiscal.codigoCidade,
                    uf: this.notaFiscal.uf,
                    email: this.notaFiscal.email,
                    notaFiscalMae: this.notaFiscal?.notaFiscalMae || undefined,
                    itens: nfItens || [],
                    parcelas: this.notaFiscal.condPag == 'parcelado' ? parcelas : [],
                    addRetirada: this.notaFiscal.addRetirada,
                    dataSaida: this.notaFiscal.dataSaida,
                    fornecedor: this.notaFiscal?.job?.fornecedor,
                    transportadora: this.notaFiscal?.transportadora,
                    volumeQuantidade: this.notaFiscal.quantidade ? Number(this.notaFiscal.quantidade) : undefined,
                    especie: this.notaFiscal.especie,
                    marca: this.notaFiscal.marca,
                    volumeNumeracao: this.notaFiscal?.numeracao || undefined,
                    pesoBruto: this.notaFiscal?.pesoBruto || undefined,
                    pesoLiquido: this.notaFiscal.pesoLiquido || undefined,
                    valorFrete: this.notaFiscal.valorFrete ? Number(this.notaFiscal.valorFrete?.replace(/\./g, '')?.replace(',', '.') || 0) : 0,
                    valorSeguro: this.notaFiscal.valorSeguro ? Number(this.notaFiscal.valorSeguro?.replace(/\./g, '')?.replace(',', '.') || 0) : 0,
                    valorDesconto: this.notaFiscal.valorDesconto ? Number(this.notaFiscal.valorDesconto?.replace(/\./g, '')?.replace(',', '.') || 0) : 0,
                    valorOutros: this.notaFiscal.valorOutros ? Number(this.notaFiscal.valorOutros?.replace(/\./g, '')?.replace(',', '.') || 0) : 0,
                    //valorBaseDeCalculo: 
                    ncm: this.notaFiscal.ncm,
                    cest: this.notaFiscal.cest,
                    cfop: this.notaFiscal.cfop,
                    fisOper: this.notaFiscal?.operacaoFiscal || undefined,
                    informacaoAdd: this.notaFiscal.informacaoAdd,
                    meioPagamento: this.notaFiscal.meioPagamento
                })

                fispreDocEmi = response.data.data.id

            } else {

                let parcelas = []
                if(this.parcelas.length > 0){
                    parcelas = await this.createParcela()
                }

                console.log('objeNotaServico >>> ', this.objeNotaServico, Number(this.objeNotaServico?.confins?.replace(/\./g, '')?.replace(',', '.' || 0)))

                const response = await this.fisDocEntity.insertOrUpdate({
                    id: this.objeNotaServico.id ? this.objeNotaServico.id : undefined,
                    emitenteCpfOrCnpj: this.objeNotaServico.cpfOrCnpjEmitente,
                    emitenteRazaoSocial: this.objeNotaServico.razaoSocialNomeEmitente,
                    cnae: this.objeNotaServico?.cnae || undefined,
                    emitenteIm: this.objeNotaServico.inscricaoMinucipal,
                    emitenteTipoEnquadramento: this.objeNotaServico.enqServico,
                    emitenteLocalEmissao: this.objeNotaServico.localEmissao,
                    emitenteLogradouro: this.objeNotaServico.emitenteLogradouro,
                    emitenteBairro: this.objeNotaServico.emitenteBairro,
                    tomadorCpfOrCnpj: this.objeNotaServico.cpfOrCnpjTomador,
                    tomadorRazaoSocial: this.objeNotaServico.razaoSocialNomeTomador,
                    tomadorIm: this.objeNotaServico.tomadorIm,
                    tomadorEndereco: this.objeNotaServico.endereco,
                    tomadorLocalRecebido: this.objeNotaServico.localRecebimento,
                    tomadorUf: this.objeNotaServico.tomadorUf,
                    tomadorNumero: this.objeNotaServico.tomadorNumero,
                    tomadorCep: this.objeNotaServico.tomadorCep,
                    tomadorEmail: this.objeNotaServico.tomadorEmail,
                    descricao: this.objeNotaServico.descricao,
                    codigoCidade: this.objeNotaServico.codigoCidade,
                    jobItens: this.objeNotaServico.jobItens.map((item) => item.id),
                    emitenteCodCidade: this.objeNotaServico.emitenteCodCidade,
                    vrlBaseCalc: Number(this.objeNotaServico?.baseCalculo?.replace(/\./g, '')?.replace(',', '.' || 0)) || undefined,
                    //vlrISS: Number(this.objeNotaServico?.iss?.replace(/\./g, '')?.replace(',', '.' || 0)) || undefined,
                    vlrIR: Number(this.objeNotaServico?.ir?.replace(/\./g, '')?.replace(',', '.' || 0)) || undefined,
                    vlrPIS: Number(this.objeNotaServico?.pis?.replace(/\./g, '')?.replace(',', '.' || 0)) || undefined,
                    vlrCOFINS: Number(this.objeNotaServico?.confins?.replace(/\./g, '')?.replace(',', '.' || 0)) || undefined,
                    vlrSCLL: Number(this.objeNotaServico?.csll?.replace(/\./g, '')?.replace(',', '.' || 0)) || undefined,
                    vrlINSS: Number(this.objeNotaServico?.inss?.replace(/\./g, '')?.replace(',', '.' || 0)) || undefined,
                    imposto: Number(this.objeNotaServico.imposto) || undefined,
                    dedutivel: Number(this.objeNotaServico.dedutivel) || undefined, 
                    dataEmissao: moment().format('YYYY-mm-dd'),
                    dataVenc: moment(this.objeNotaServico.dateVenc).format('YYYY-mm-dd'),
                    vlrLiquido: this.objeNotaServico.liquidos ? Number(this.objeNotaServico.liquidos?.replace(/\./g, '')?.replace(',', '.') || 0) : 0,
                    regimeTributario: this.objeNotaServico?.regimeTributario || undefined,
                    enquadramentoServico: this.objeNotaServico?.enquadramento || undefined,
                    tributacaoMunicipal: this.objeNotaServico?.tributacaoMunicipal?.id || undefined,
                    aliquota: this.objeNotaServico.aliquota || 0,
                    job: this.objeNotaServico.job?.id || this.objeNotaServico.job,
                    tipoServico: this.objeNotaServico.tipoServico,
                    parcelas: parcelas
                })

                fisDocService = response.data.data.id
            }

            await this.emissaoDoc.insertOrUpdate({
                ...this.emitNotaFiscal,
                valorNf: undefined,
                typeNf: undefined,
                tipoNotaFiscal: this.emitNotaFiscal.typeNf,
                destinatario: !this.emitNotaFiscal.notaFiscalDeRemessa ? (this.emitNotaFiscal.destinatario.id ? this.emitNotaFiscal.destinatario.id : this.emitNotaFiscal.destinatario) : undefined,
                destinatarioFornecedor: this.emitNotaFiscal.notaFiscalDeRemessa ? (this.emitNotaFiscal.destinatario.id ? this.emitNotaFiscal.destinatario.id : this.emitNotaFiscal.destinatario) : undefined,
                statusNf: this.emitNotaFiscal.statusNf,
                notaFiscal: fispreDocEmi,
                notaFiscalServico: fisDocService,
                valueNf: this.emitNotaFiscal.typeNf == 'Nota Fiscal de Serviço' ? this.emitNotaFiscal?.valorNf : this.emitNotaFiscal?.valorNf / 100,
                id: this.emitNotaFiscal.id ? this.emitNotaFiscal.id : undefined
            })

            this.$router.back()
        },

        async searchNotaFisca(){
            const response = await Vue.prototype.$http.post(`/View/run`,
                {
                    "params": [
                        { name: "id", dataType: "string", value: null },
                        { name: 'chaveAcesso', dataType: 'string', value: this.searchNotaChaveAcesso }
                    ],
                    "viewId": "2a39c593-02d0-46d4-be8c-6dc43dc18c9a",
                    "page": 1,
                    "limit": 1
                }
            );

            this.itemsData = response.data.data.data
        },


    },
    watch: {
        async ['notaFiscal.job'](job){
            if(this.emitNotaFiscal.typeNf !== 'Nota Fiscal de Serviço'){
               this.romaneios = await this.getRomaneios(job?.id || job)

                if(this.emitNotaFiscal.notaFiscalDeRemessa){
                    
                    let fornecedor = this.romaneios[0]?.romaneiopackinglist[0]?.listaDeEmbarqueItem[0].fornecedor
                }
            }
            
        },

        async selected(value){

            if(value.length > 0){
                await this.getClientes(value[0].destinatario)

                this.emitNotaFiscal = {
                    destinatario: value[0].destinatario,
                    notaFiscalDeRemessa: false,
                    statusNf: 'Pendente',
                    typeNf: 'Nota Fiscal',
                    id: undefined
                }


                this.notaFiscal = {
                    codigo: value[0].notaFiscal[0].codigo,
                    filial: value[0].notaFiscal[0].filial,
                    job: value[0].notaFiscal[0].job,
                    romaneio: [],
                    icms: value[0].notaFiscal[0].aliIcms,
                    baseIcms: value[0].notaFiscal[0].baseIcms,
                    defFiscais: value[0].notaFiscal[0].defFiscais || undefined,
                    cnpj: value[0].notaFiscal[0].cnpj,
                    itens: [],
                    uf: value[0].notaFiscal[0].uf,
                    email: value[0].notaFiscal[0].email,
                    bairro: value[0].notaFiscal[0].destinatarioBairro,
                    numero: value[0].notaFiscal[0].destinatarioNumero,
                    logradouro: value[0].notaFiscal[0].destinatarioLogradouro,
                    cidade: value[0].notaFiscal[0].destinatarioCidade,
                    cep: value[0].notaFiscal[0].destinatarioCep,
                    condPag: value[0].notaFiscal[0].condicaoPagamento,
                    codigoCidade: value[0].notaFiscal[0].codigoCidade,
                    notaFiscalMae: value[0].notaFiscal[0]?.notaFiscalMae || undefined,
                    addRetirada: value[0].notaFiscal[0]?.addRetirada,
                    dataSaida: moment(value[0].notaFiscal[0]?.dataSaida).format('YYYY-MM-DD'),
                    ncm: value[0].notaFiscal[0].ncm,
                    cest: value[0].notaFiscal[0].cest,
                    informacaoAdd: value[0].notaFiscal[0].informacaoAdd
                }

                this.notaFiscal.notaFiscalMae = value[0] ? value[0].chaveAcesso : ''
                this.componentKey += 1

            } else {
                this.notaFiscal = {}
            }

        },
    },
    async created(){
        const typeNf = this.$route.params.typeNf || 'Nota Fiscal';
        this.emitNotaFiscal.typeNf = typeNf

        const id = this.$route.query.id

        if(this.notaFiscal.notaFiscalMae && this.itemsData.length == 0){
            this.searchNotaChaveAcesso = this.objNf.notaFiscalMae
            await this.searchNotaFisca()
        }

        if(id){
            await this.getItemNf(id)
        }

        if(this.emitNotaFiscal.typeNf != 'Nota Fiscal de Serviço') this.getJob(undefined)

        if(this.emitNotaFiscal.typeNf == 'Nota Fiscal de Serviço') this.getClientes(undefined)

        if(this.emitNotaFiscal.notaFiscalDeRemessa) this.getFornecedores()
    }
}
</script>

<style scoped>
.my-custom-dialog {
    margin: 0;
    margin-right: 10px;
    height: 100%;
    width: 565px;
    max-height: 100% !important;
}
.my-custom-card {
    min-height: 100%;
  }
</style>